export function calculateLocation() {
  if (this.state.panoramaOn) return false;
  let px = this.state.mapWalkerX;
  let py = this.state.mapWalkerY;
  const { minimaps } = this.state;
  const { selectedMinimap } = this.state;
  const { tour } = this.state;
  if (
    tour.minimap &&
    minimaps.length > 0 &&
    minimaps[selectedMinimap] &&
    tour.originX != null &&
    tour.originY != null &&
    tour.width != null &&
    tour.height != null &&
    tour.ppm != null
  ) {
    const { hotspots, custom } = minimaps[selectedMinimap];
    let foundHotspot: any = null;
    const poseSweep = this.pose.sweep;
    hotspots.forEach((hotspot: any) => {
      if (hotspot.scanId === poseSweep) {
        hotspot.active = true;
        foundHotspot = hotspot;
      } else {
        hotspot.active = false;
      }
    });
    if (foundHotspot) {
      px = foundHotspot.x;
      py = foundHotspot.y;
    } else if (!custom) {
      px = (((this.pose.position.x + tour.originX * -1) * tour.ppm) / tour.width) * 100;
      py = 100 + (((this.pose.position.z + tour.originY) * tour.ppm) / tour.height) * 100;
    }
  }
  return { px, py, minimaps };
}
